// update localStorageVersion every time a new property is added or removed from the zustand store;
// in the case when it is needed to update the key name - create a migration manually.
// for more see zustand documentation and SWEEP-8185
import { versionStringToUniqueNumber } from './localStorageUtils'
import { playerStoreInitialValues, playerStoreKey, playerStoreKeys } from './playerStore/playerStoreConstants'
import { casinoStoreInitialValues, casinoStoreKey, casinoStoreKeys } from './casinoStore/casinoStoreConstants'

// eslint-disable-next-line
const localStorageDevVersion = 46

export const zustandLocalStorageVersion = () =>
  process.env.NODE_ENV === 'production'
    ? versionStringToUniqueNumber(process.env.REACT_APP_VERSION)
    : localStorageDevVersion

export const zustandLocalStorageName = 'app-storage'

export const storeInitialState = {
  [playerStoreKey]: playerStoreInitialValues,
  [casinoStoreKey]: casinoStoreInitialValues
}

export const zustandStoreKeys = [playerStoreKey, casinoStoreKey]

// to exclude nested property from localStorage (or any object using deepRemoveKeysByPaths)
// set key as `${casinoStoreKeys.casinoLobby}.categories`, e.g.
export const excludedPlayerDataFromLocalStorage = [playerStoreKeys.activeTabId, playerStoreKeys.allowAutomaticLogin]

export const excludedCasinoDataFromLocalStorage = [
  casinoStoreKeys.casinoFooterHideSweepstakesRulesLink,
  casinoStoreKeys.casinoLobby
]
